import Button from "../button";
import DeleteIcon from "../icons/delete-icon";
import cn from "classnames";
import { useTranslation } from "react-i18next";

type ConfirmationCardProps = {
  onCancel: () => void;
  onDelete: () => void;
  title?: string;
  icon?: any;
  description?: string;
  cancelBtnClassName?: string;
  deleteBtnClassName?: string;
  cancelBtnText?: string;
  deleteBtnText?: string;
  cancelBtnLoading?: boolean;
  deleteBtnLoading?: boolean;
};

const ConfirmationCard: React.FC<ConfirmationCardProps> = ({
  onCancel,
  onDelete,
  icon,
  title ,
  description = "delete-item-confirm",
  cancelBtnText = "Cancel",
  deleteBtnText = "Delete",
  cancelBtnClassName,
  deleteBtnClassName,
  cancelBtnLoading,
  deleteBtnLoading,
}) => {

  const { t } = useTranslation(["home"]);

  return (
    <div className="p-4 pb-6 bg-light m-auto max-w-sm w-full rounded-md md:rounded-xl sm:w-[24rem]">
      <div className="w-full h-full text-center">
        <div className="flex h-full flex-col justify-between">
          {icon ? (
            icon
          ) : (
            <DeleteIcon className="mt-4 w-12 h-12 m-auto text-accent" />
          )}
          <p className="text-heading text-xl font-bold mt-4">{title}</p>
          <p className="text-grey py-2 px-6 text-sm ">{description}</p>
          <div className="flex items-center justify-center gap-4 w-full mt-8">
            <Button
              onClick={onCancel}
              loading={cancelBtnLoading}
              disabled={cancelBtnLoading}
              variant="custom"
              className={cn(
                " py-2 px-4 bg-transparent !border !border-grey !py-1 hover:bg-accent-hover focus:bg-accent-hover !text-grey transition ease-in duration-200 text-center text-base font-semibold rounded shadow-md",
                cancelBtnClassName
              )}
            >
              {t(cancelBtnText)}
            </Button>

            <Button
              onClick={onDelete}
              loading={deleteBtnLoading}
              disabled={deleteBtnLoading}
              variant="custom"
              className={cn(
                "py-2 px-4 bg-red-600  !py-1 text-light transition ease-in duration-200 text-center text-base font-semibold rounded shadow-md",
                deleteBtnClassName
              )}
            >
              {t(deleteBtnText)}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationCard;
